module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (false) ? _c('footer', {
    staticClass: "footer"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Copyright © Studio Metatron Ltd.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69f1a710","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/template/Footer.vue
// module id = 206
// module chunks = 1